export const DRAWER_WIDTH = 300
